(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('destination', function(searchUnitService) {
    return {
        restrict: 'A',
        link(scope, el, attr) {
            if (attr.destination != null) {
                searchUnitService.setDestination(angular.extend({ landing: true }, JSON.parse(attr.destination)));
            }
        }
    };
});
})();
